import React, { useEffect, useState } from 'react';
import SEO from '../../components/SEO';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import HeroSection from './components/HeroSection';
import PopularRoutes from './components/PopularRoutes';
import TourPackages from './components/TourPackages';
import TempoTravellerRoutes from './components/TempoTravellerRoutes';
import ForceUrbaniaRoutes from './components/ForceUrbaniaRoutes';
import LuxuryCabs from './components/LuxuryCabs';
import TaxiServices from './components/TaxiServices';
import CustomerReviews from './components/CustomerReviews';

const Homepage = () => {
  const [showIntroVideo, setShowIntroVideo] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    
    const hasSeenIntro = sessionStorage.getItem('hasSeenIntro');
    
    if (!hasSeenIntro) {
      setShowIntroVideo(true);
      
      const timer = setTimeout(() => {
        setShowIntroVideo(false);
        sessionStorage.setItem('hasSeenIntro', 'true');
      }, 3000);
      
      return () => clearTimeout(timer);
    }
  }, []);

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Advait Tour and Travels",
    "image": `${window.location?.origin}/assets/images/image-1768073645428.png`,
    "@id": window.location?.origin,
    "url": window.location?.origin,
    "telephone": "+91-79986-66660",
    "priceRange": "$$",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "New Shivpuri",
      "addressLocality": "Ludhiana",
      "addressRegion": "Punjab",
      "postalCode": "141008",
      "addressCountry": "IN"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 30.9010,
      "longitude": 75.8573
    },
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
      ],
      "opens": "00:00",
      "closes": "23:59"
    },
    "sameAs": [
      window.location?.origin
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "reviewCount": "250"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Taxi Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Ludhiana to Delhi Taxi Service",
            "description": "24/7 Ludhiana to Delhi taxi hire service with professional drivers. Best cab service in Ludhiana for outstation travel."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Delhi to Ludhiana Cab Service",
            "description": "Reliable Delhi to Ludhiana cab booking service. Premium taxi from Delhi to Ludhiana with experienced drivers."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Chandigarh to Haridwar One Way",
            "description": "One way taxi service from Chandigarh to Haridwar. Book taxi city to city with Advait Tour and Travels."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Force Urbania Booking Ludhiana",
            "description": "Luxury Force Urbania for group travel from Ludhiana. Premium 16-seater vehicle for outstation trips."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Tempo Traveller Ludhiana",
            "description": "Comfortable tempo traveller for outstation trips from Ludhiana. 12, 17, and 25 seater options available."
          }
        }
      ]
    }
  };

  return (
    <>
      <SEO
        title="Advait Tour and Travels - Best Taxi Service in Ludhiana | Ludhiana to Delhi Taxi | 24/7 Cab Booking | Call +91-79986-66660"
        description="Book premium taxi services in Ludhiana with Advait Tour and Travels. Ludhiana to Delhi taxi, Delhi to Ludhiana cab, Chandigarh to Haridwar one way, book taxi city to city. Best cab service in Ludhiana. 24/7 airport taxi, Force Urbania, Tempo Traveller. Call +91-79986-66660"
        keywords="advait tour and travels, ludhiana to delhi taxi, delhi to ludhiana cab, chandigarh to haridwar one way, book taxi city to city, best cab service in ludhiana, taxi service Ludhiana, cab booking Ludhiana, airport taxi Ludhiana, Force Urbania booking, Tempo Traveller Ludhiana, outstation taxi, 7998666660, 79986-66660"
        ogTitle="Advait Tour and Travels - Best Taxi Service in Ludhiana | Book Now"
        ogDescription="Trusted taxi service provider in Ludhiana. Book Ludhiana to Delhi taxi, Delhi to Ludhiana cab, Chandigarh to Haridwar one way. Available 24/7 with experienced drivers. Call +91-79986-66660"
        ogUrl={window.location?.origin}
        canonicalUrl={window.location?.origin}
        structuredData={structuredData}
      />
      
      {showIntroVideo && (
        <div className="fixed inset-0 z-[100] bg-black flex items-center justify-center">
          <video
            autoPlay
            muted
            playsInline
            className="w-full h-full object-cover"
          >
            <source src="/assets/videos/intro.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      )}
      
      <div className="min-h-screen bg-background">
        <Header />
        
        <main>
          <HeroSection />
          <PopularRoutes />
          <TourPackages />
          <TempoTravellerRoutes />
          <ForceUrbaniaRoutes />
          <LuxuryCabs />
          <CustomerReviews />
          <TaxiServices />
        </main>

        <Footer />
      </div>
    </>
  );
};

export default Homepage;